import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import StarField from '../components/StarField';
import styles from './Consent.module.css';

export default function Consent() {
  const { dispatch } = useApp();
  const [exiting, setExiting] = useState(false);

  const handleContinue = () => {
    setExiting(true);
    setTimeout(() => dispatch({ type: 'SET_PAGE', payload: 'quiz' }), 800);
  };

  const handleLeave = () => {
    dispatch({ type: 'SET_PAGE', payload: 'landing' });
  };

  return (
    <div className={`${styles.container} ${exiting ? styles.exiting : ''}`}>
      <StarField density={80} speed={0.2} />
      <div className={styles.overlay} />
      <div className={styles.card}>
        <div className={styles.content}>
          <p className={styles.item}>本装置并非心理测试，不提供科学结论。</p>
          <p className={styles.item}>所有计算均在您的设备本地完成，不会上传任何数据。</p>
          <p className={styles.item}>结果仅为基于荣格原型的象征性艺术表达，反映"此刻的状态偏向"。</p>
          <p className={styles.item}>未来可能邀请您启用摄像头进行面部情绪映射（可选，当前版本预留接口）。</p>
        </div>
        <div className={styles.buttons}>
          <button className={styles.primary} onClick={handleContinue}>
            我理解并继续
          </button>
          <button className={styles.secondary} onClick={handleLeave}>
            离开
          </button>
        </div>
      </div>
    </div>
  );
}
